import { PageRoutes } from '../page-routes';
import { guardNavigate } from '../helpers/navigation-guard';

export const Navigation = () => {
    return (
        <div id="header_2">
            <div id="menutop">
                <div className="menutop_main">
                    <a
                        href={PageRoutes.Welcome}
                        className="internal-link"
                        onClick={(event) => {
                            event.preventDefault();
                            guardNavigate(PageRoutes.Welcome);
                        }}
                    >
                        AKTUELL
                    </a>
                </div>
                <div className="menutop_main">
                    <a
                        href={PageRoutes.Archive}
                        className="internal-link"
                        onClick={(event) => {
                            event.preventDefault();
                            guardNavigate(PageRoutes.Archive);
                        }}
                    >
                        R&Uuml;CKBLICK KONZERTE
                    </a>
                </div>
                <div className="menutop_main">
                    <a
                        href={PageRoutes.Tickets}
                        className="internal-link"
                        onClick={(event) => {
                            event.preventDefault();
                            guardNavigate(PageRoutes.Tickets);
                        }}
                    >
                        TICKETS
                    </a>
                </div>
                <div className="menutop_main">
                    <a
                        href={PageRoutes.Playlists}
                        className="internal-link"
                        onClick={(event) => {
                            event.preventDefault();
                            guardNavigate(PageRoutes.Playlists);
                        }}
                    >
                        MARTINS PLAYLISTS
                    </a>
                </div>
                <div className="menutop_main">
                    <a
                        href={PageRoutes.Videos}
                        className="internal-link"
                        onClick={(event) => {
                            event.preventDefault();
                            guardNavigate(PageRoutes.Videos);
                        }}
                    >
                        VIDEOS
                    </a>
                </div>
                <div className="menutop_main">
                    <a
                        href={PageRoutes.Links}
                        className="internal-link"
                        onClick={(event) => {
                            event.preventDefault();
                            guardNavigate(PageRoutes.Links);
                        }}
                    >
                        LINKS
                    </a>
                </div>
            </div>
        </div>
    );
};
